import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { validate } from '~common/validator';
import { required } from '~common/validator/validations';
import { PasswordInput } from '~common/components/form/password-input.component';
import { TextInputFieldProps } from '~common/components/form/props';

export interface PasswordFormData {
  password: string;
}

export interface PasswordValidationParameters {
  password: string;
}

interface Props extends TextInputFieldProps<string> {
  autoFocus?: boolean;
}

export const PasswordField: React.FunctionComponent<Props> = ({ label, autoFocus, ...rest }) => {
  const { t } = useTranslation();
  return (
    <Field
      label={label ?? t('form.label.password')}
      name={'password'}
      render={(renderProps): ReactNode => (
        <PasswordInput autoFocus={autoFocus} allowShowPassword {...renderProps} />
      )}
      {...rest}
    />
  );
};

//TODO: Fix validation error translations for modules other than web
export const PasswordValidator = (
  values: any & PasswordFormData,
): PasswordValidationParameters => ({
  password: validate(values.password, [required()]),
});



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/components/form/password-field.component.tsx